export default "__VITE_ASSET__CbSzi8Mo__"